/* eslint-disable react/destructuring-assignment */
import React, { Component, useState } from 'react';
import { withRouter } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { connect } from 'react-redux';
import {
  Button,
  Col,
  Form,
  Layout,
  Row,
  Card,
  notification,
  Typography,
  Modal,
} from 'antd';
import { generatePreviewHtml, generatePreviewCss } from '../../assets/html/tcleDefaultTerm';

import { institutionService } from '../../services/institution.service';
import { pathRoutes } from '../../routes';
import {
  canonicalizeTcleHtml,
  createTcleQuillLoadValue,
  createTcleMeasurementRoot,
  discardTcleClipboardDelta,
  ensureTclePreviewFonts,
  getTcleCharacterBreakdown,
  getTcleCharacterCount,
  getTcleContentValidation,
  getTcleLayoutFeedback,
  getTclePasteCharacterBudget,
  getTclePlainText,
  getTclePreviewModalWidth,
  getTcleSaveErrorDetails,
  inspectTcleClipboardHtml,
  preserveTcleClipboardBold,
  preserveTcleClipboardItalic,
  renderTcleMeasurementHtml,
  saveCanonicalTcle,
  sanitizeTcleClipboardDelta,
  truncateTcleClipboardDelta,
  TCLE_CHARACTER_LIMIT,
  TCLE_LAYOUT_SAFETY_GAP_PX,
  TCLE_MEASUREMENT_CANVAS_WIDTH_PX,
} from '../../helpers/tcleContent';

const { Content } = Layout;

const TCLE_EDITOR_FORMAT_CSS = `
  .tcle-editor-surface .ql-editor em,
  .tcle-editor-surface .ql-editor i {
    font-style: italic;
    font-weight: 400;
  }
  .tcle-editor-surface .ql-editor strong,
  .tcle-editor-surface .ql-editor b,
  .tcle-editor-surface .ql-editor strong em,
  .tcle-editor-surface .ql-editor strong i,
  .tcle-editor-surface .ql-editor em strong,
  .tcle-editor-surface .ql-editor i strong {
    font-weight: 700;
  }
`;

function TcleEditorToolbar() {
  const textButtonStyle = { width: 'auto', padding: '0 8px' };
  return (
    <div id="tcle-editor-toolbar">
      <span className="ql-formats">
        <button type="button" className="ql-bold" title="Negrito" aria-label="Negrito" />
        <button type="button" className="ql-italic" title="Itálico" aria-label="Itálico" />
        <button
          type="button"
          className="ql-clean"
          title="Limpar formatação da seleção"
          aria-label="Limpar formatação da seleção"
        />
      </span>
      <span className="ql-formats">
        <button
          type="button"
          className="ql-normalize"
          title="Padronizar todo o texto"
          aria-label="Padronizar todo o texto"
          style={textButtonStyle}
        >
          Padronizar texto
        </button>
      </span>
    </div>
  );
}

class PreAnesthesiaSettingsTcle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      patientPreSettingsTcle: '',
      modalVisible: false,
      value: '',
      editorValue: '',
      charCount: 0,
      layoutStatus: 'pending',
      layoutMetrics: null,
      legacyOversized: false,
      disabled: false,
      quillRef: null,
      previewhtml: '',
      measurementHtml: '',
    };
    // Phase 11A (card3226/AXREG-1481): the editor must not advertise formatting the
    // persistence contract cannot keep. Strike is not backend-preservable, so it is not
    // offered here; pasted strike keeps its text and loses only the strike formatting.
    this.formats = ['bold', 'italic'];
    this.modules = {
      toolbar: {
        container: '#tcle-editor-toolbar',
        handlers: {
          normalize: () => this.handleNormalizeTcle(),
        },
      },
      history: {
        delay: 2000,
        maxStack: 6020,
        userOnly: true,
      },
      clipboard: {
        matchers: [
          ['*', sanitizeTcleClipboardDelta],
          ['b, strong', preserveTcleClipboardBold],
          ['i, em', preserveTcleClipboardItalic],
          ['script, style, iframe, object, embed, img, svg, math, video, audio, form', discardTcleClipboardDelta],
        ],
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.saveInFlight = false;
  }

  async componentDidMount() {
    this.componentActive = true;
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', this.handlePopstate);
    const valueDb = await institutionService.getSettingsPreTcle();
    const canonicalValue = canonicalizeTcleHtml(valueDb.value);
    const clipboardInspection = inspectTcleClipboardHtml(valueDb.value);
    const editor = this.reactQuillRef && this.reactQuillRef.getEditor();
    const editorValue = createTcleQuillLoadValue(
      canonicalValue,
      editor && editor.clipboard && editor.clipboard.convert.bind(editor.clipboard),
    );
    this.setState({
      value: canonicalValue,
      editorValue,
      charCount: getTcleCharacterCount(canonicalValue),
      legacyOversized: getTcleCharacterCount(canonicalValue) > TCLE_CHARACTER_LIMIT,
      measurementHtml: this.generateTclePreview(canonicalValue),
    });

    if (clipboardInspection.dangerousContent || clipboardInspection.unsupportedFormatting) {
      notification.warning({
        message: clipboardInspection.dangerousContent
          ? 'Conteúdo incompatível foi removido do termo carregado'
          : 'A formatação do termo carregado foi ajustada',
        description: 'Revise o conteúdo antes de salvar.',
      });
    }

  }

  componentWillUnmount() {
    this.componentActive = false;
    this.layoutMeasureRoot = null;
    this.layoutMeasureRef = null;
    window.removeEventListener('popstate', this.handlePopstate);
    this.setReactQuillRef(null);
  }

  componentDidUpdate(previousProps, previousState) {
    if (previousState.measurementHtml !== this.state.measurementHtml) {
      this.renderTcleLayoutMeasurement();
    }
  }

  handleChange(e, delta, source, editor) {
    const canonicalValue = canonicalizeTcleHtml(e);
    if (canonicalValue === this.state.value) return;
    const charCount = getTcleCharacterCount(canonicalValue);
    const editorValue = this.state.editorValue && this.state.editorValue.ops && editor
      ? editor.getContents()
      : canonicalValue;
    this.setState({
      value: canonicalValue,
      editorValue,
      charCount,
      layoutStatus: 'pending',
      layoutMetrics: null,
      legacyOversized: this.state.legacyOversized && charCount > TCLE_CHARACTER_LIMIT,
      measurementHtml: this.generateTclePreview(canonicalValue),
    });
  }

  handleSubmit = async (value) => {
    if (this.saveInFlight) return;
    const canonicalValue = canonicalizeTcleHtml(value);
    const validation = getTcleContentValidation(
      canonicalValue,
      this.state.layoutStatus === 'valid',
    );

    if (!validation.valid) {
      notification.error({
        message: validation.empty
          ? 'Não é possível salvar um termo em branco'
          : validation.overCharacterLimit
            ? `O termo excede o limite técnico de ${TCLE_CHARACTER_LIMIT} caracteres`
            : 'O termo excede a área segura de uma página',
        description: validation.overCharacterLimit
          ? `Reduza o conteúdo para ${TCLE_CHARACTER_LIMIT} caracteres ou menos.`
          : 'Reduza ou reorganize o conteúdo indicado no editor antes de salvar.',
      });
      return;
    }

    this.saveInFlight = true;
    let saveSucceeded = false;
    this.setState({ loading: true });

    try {
      const onlyValue = getTclePlainText(canonicalValue).trim();
      if (onlyValue.length > 0) {
        await saveCanonicalTcle(canonicalValue, institutionService.settingsPreTcle);
        saveSucceeded = true;
        this.setState({ value: canonicalValue });
        notification.success({
          message: 'Configurações do termo alteradas com sucesso',
        });
        setTimeout(() => {
          this.saveInFlight = false;
          this.props.history.push({
            pathname: pathRoutes.pre_anesthesia,
          });
        }, 2000);
      } else {
        notification.error({
          message: 'Não é possível salvar um termo em branco',
        });
      }
    } catch (error) {
      const details = getTcleSaveErrorDetails(error);
      console.error('TCLE save failed', {
        category: details.category,
        status: details.status,
        correlationId: details.correlationId,
      });
      notification.error({
        message: 'Não foi possível salvar o termo',
        description: details.userDescription,
      });
    } finally {
      if (!saveSucceeded) {
        this.saveInFlight = false;
        this.setState({ loading: false });
      }
    }
  }

  handlePaste = (event) => {
    const clipboardData = event.clipboardData;
    if (!clipboardData) return;
    const editor = this.reactQuillRef && this.reactQuillRef.getEditor();
    if (!editor) return;

    const sourceHtml = clipboardData.getData('text/html');
    const sourceText = clipboardData.getData('text/plain');
    const inspection = inspectTcleClipboardHtml(sourceHtml);
    const selection = editor.getSelection(true);
    const Delta = editor.getContents().constructor;
    let pastedDelta;

    if (sourceHtml) {
      const canonicalHtml = canonicalizeTcleHtml(sourceHtml);
      pastedDelta = sanitizeTcleClipboardDelta(null, editor.clipboard.convert(canonicalHtml));
    } else {
      pastedDelta = new Delta().insert(sourceText);
    }

    const selectedText = editor.getText(selection.index, selection.length);
    const availableCharacters = getTclePasteCharacterBudget(
      editor.root.innerHTML,
      Array.from(selectedText).length,
    );
    const limitedPaste = truncateTcleClipboardDelta(pastedDelta, availableCharacters);

    event.preventDefault();
    const update = new Delta()
      .retain(selection.index)
      .delete(selection.length)
      .concat(limitedPaste.delta);
    editor.updateContents(update, 'user');
    editor.setSelection(selection.index + limitedPaste.delta.length(), 0, 'silent');

    if (limitedPaste.truncated) {
      const discardedLabel = limitedPaste.discarded === 1 ? 'caractere' : 'caracteres';
      notification.warning({
        message: `Limite de ${TCLE_CHARACTER_LIMIT} caracteres atingido`,
        description: `Foi inserida somente a parte que cabia. ${limitedPaste.discarded} ${discardedLabel} não ${limitedPaste.discarded === 1 ? 'foi inserido' : 'foram inseridos'}. O cursor permaneceu após o último caractere aceito.${inspection.dangerousContent || inspection.unsupportedFormatting ? ' A formatação incompatível também foi ajustada.' : ''}`,
      });
    } else if (inspection.dangerousContent || inspection.unsupportedFormatting) {
      notification.warning({
        message: inspection.dangerousContent
          ? 'Conteúdo incompatível foi removido ao colar'
          : 'A formatação colada foi ajustada',
        description: 'Foram mantidos parágrafos, quebras de linha, negrito e itálico. Formatações incompatíveis foram removidas, preservando o conteúdo textual.',
      });
    } else {
      notification.info({
        message: 'Conteúdo colado no padrão do TCLE',
        description: 'Parágrafos, quebras de linha, negrito e itálico compatíveis foram mantidos.',
      });
    }
  }

  applyTcleNormalization = () => {
    const editor = this.reactQuillRef && this.reactQuillRef.getEditor();
    if (!editor) return;
    const selection = editor.getSelection();
    editor.history.cutoff();
    editor.formatText(0, Math.max(0, editor.getLength() - 1), {
      bold: false,
      italic: false,
    }, 'user');
    editor.history.cutoff();
    if (selection) {
      editor.setSelection(Math.min(selection.index, editor.getLength() - 1), 0, 'silent');
    }
    notification.success({
      message: 'Texto padronizado',
      description: 'O conteúdo e as quebras foram mantidos; a formatação manual foi removida.',
    });
  }

  handleNormalizeTcle = () => {
    Modal.confirm({
      title: 'Padronizar todo o texto?',
      content: 'O conteúdo e as quebras serão mantidos, mas negrito, itálico e outras formatações manuais serão removidos.',
      okText: 'Padronizar',
      cancelText: 'Cancelar',
      onOk: this.applyTcleNormalization,
    });
  }

  handlePreviewClick = async () => {
    this.setState({
      modalVisible: true,
      previewhtml: this.generateTclePreview(this.state.value),
    });
  }

  generateTclePreview = (value) => {
    const parsed = new DOMParser().parseFromString(canonicalizeTcleHtml(value), 'text/html');
    Array.from(parsed.body.querySelectorAll('p')).forEach((paragraph) => {
      paragraph.style.margin = '0';
      paragraph.style.width = 'auto';
      paragraph.style.float = 'left';
    });
    let institution = null;
    try {
      institution = JSON.parse(localStorage.getItem('selected-institution'));
    } catch (error) {
      institution = null;
    }
    return generatePreviewHtml(parsed.body.innerHTML, generatePreviewCss(), institution);
  }

  setLayoutMeasureRef = (element) => {
    this.layoutMeasureRef = element;
    this.layoutMeasureRoot = createTcleMeasurementRoot(element);
    if (element && this.state.measurementHtml) this.renderTcleLayoutMeasurement();
  }

  renderTcleLayoutMeasurement = () => {
    if (!renderTcleMeasurementHtml(this.layoutMeasureRoot, this.state.measurementHtml)) return;
    this.scheduleLayoutMeasurement();
  }

  scheduleLayoutMeasurement = () => {
    ensureTclePreviewFonts(document).then(() => {
      if (this.componentActive) window.requestAnimationFrame(this.measureTcleLayout);
    });
  }

  measureTcleLayout = () => {
    if (!this.componentActive) return;
    const container = this.layoutMeasureRoot;
    if (!container) return;
    const root = container.querySelector('#term-header-1');
    const page = container.querySelector('#tcle-page-boundary');
    const custom = container.querySelector('#tcle-custom-content');
    const protectedRegion = container.querySelector('#tcle-protected-region');
    const contentEnd = container.querySelector('#tcle-page-content-end');
    if (!root || !page || !custom || !protectedRegion || !contentEnd) return;

    const pageRect = page.getBoundingClientRect();
    const customRect = custom.getBoundingClientRect();
    const protectedRect = protectedRegion.getBoundingClientRect();
    const contentEndRect = contentEnd.getBoundingClientRect();
    const customTop = customRect.top - pageRect.top;
    const customBottom = customRect.bottom - pageRect.top;
    const protectedRegionTop = protectedRect.top - pageRect.top;
    const protectedContentBottom = contentEndRect.bottom - pageRect.top;
    const pageBottom = pageRect.bottom - pageRect.top;
    const gap = protectedRegionTop - customBottom;
    const horizontalOverflow = custom.scrollWidth > custom.clientWidth + 1
      || customRect.right > pageRect.right + 1;
    const geometryValid = gap >= TCLE_LAYOUT_SAFETY_GAP_PX
      && protectedContentBottom <= pageBottom + 1
      && !horizontalOverflow;

    this.setState({
      layoutStatus: geometryValid ? 'valid' : 'invalid',
      layoutMetrics: {
        customTop,
        customBottom,
        gap,
        horizontalOverflow,
        pageBottom,
        protectedContentBottom,
        protectedRegionTop,
        safetyGap: TCLE_LAYOUT_SAFETY_GAP_PX,
      },
    });
  }

  handleCancel = () => {
    this.setState({ modalVisible: false });
  }

  handlePopstate = () => {
    Modal.confirm({
      title: 'Atenção',
      content: 'Ao retornar os dados não serão salvos, deseja continuar?',
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.props.history.push({
          pathname: pathRoutes.pre_anesthesia,
        });
      },
    });
  };

  myUndo = () => {
    const myEditor = this.reactQuillRef.getEditor();
    return myEditor.history.undo();
  }

  myRedo = () => {
    const myEditor = this.reactQuillRef.getEditor();
    return myEditor.history.redo();
  }

  redirectToPreAnesthesia = () => {
    this.props.history.push({
      pathname: pathRoutes.pre_anesthesia,
    });
    return null;
  }

  setReactQuillRef = (ref) => {
    if (this.reactQuillRef === ref) return;
    if (this.reactQuillRef) {
      this.reactQuillRef.getEditor().root.removeEventListener('paste', this.handlePaste, true);
    }
    this.reactQuillRef = ref;
    if (ref) ref.getEditor().root.addEventListener('paste', this.handlePaste, true);
  }

  render() {
    const contentValidation = getTcleContentValidation(
      this.state.value,
      this.state.layoutStatus === 'valid',
    );
    const nearLimit = this.state.charCount >= Math.floor(TCLE_CHARACTER_LIMIT * 0.9);
    const characterBreakdown = getTcleCharacterBreakdown(this.state.value);
    const layoutFeedback = getTcleLayoutFeedback(
      this.state.layoutMetrics, this.state.layoutStatus,
    );
    const layoutFeedbackText = layoutFeedback && (layoutFeedback.kind === 'height'
      ? `Espaço disponível para o termo: ${layoutFeedback.percent}% ocupado`
      : {
        pending: 'Calculando espaço…',
        width: 'Largura disponível para o termo excedida',
        spacing: 'Espaço reservado às assinaturas comprometido',
      }[layoutFeedback.kind]);
    const saveDisabled = this.state.loading || !contentValidation.valid;
    const previewModalWidth = getTclePreviewModalWidth(
      typeof window === 'undefined' ? undefined : window.innerWidth,
    );
    const institution = JSON.parse(localStorage.getItem('selected-institution'));
    const user = JSON.parse(localStorage.getItem('user'));
    const userInstitutions = JSON.parse(localStorage.getItem('user-permissions')).institutions;
    const findUserInstitution = userInstitutions.find((i) => i.id === institution.id);
    const institutionAcepted = (institution.is_group || institution.group_id === null
      || findUserInstitution) ? (
        <Content>
          <Form>
            <Row>
              <Col xs={24} sm={20}>
                <h1 className="title">
                  Personalização do Termo de Consentimento Livre e Esclarecido (TCLE)
                </h1>
              </Col>
              <Col xs={0} sm={4}>
                <Button
                  type="primary"
                  className="add-procedure"
                  htmlType="button"
                  loading={this.state.loading}
                  disabled={saveDisabled}
                  onClick={() => this.handleSubmit(this.state.value)}
                >
                  SALVAR
                </Button>
              </Col>
            </Row>
            <div style={{ margin: 20 }} />
            <Card
              title="Termo de Consentimento Livre e Esclarecido (TCLE)"
              headStyle={{ backgroundColor: '#f2f2f2', paddingLeft: 16 }}
              size="default"
              bodyStyle={{ paddingTop: 5 }}
            >
              <Row gutter={28}>
                <Row style={{ marginTop: '20px' }}>
                  <Typography.Text
                    style={{
                      fontWeight: 400,
                      marginLeft: 11,
                    }}
                  >
                    Informe apenas os parágrafos do documento.
                    Os dados do paciente e anestesista serão impressos automaticamente no termo.
                  </Typography.Text>
                </Row>
              </Row>
            </Card>
            <Card
              className="tcle-editor-surface"
              headStyle={{ backgroundColor: '#f2f2f2' }}
              size="default"
              bodyStyle={{ paddingTop: 5, height: '590px' }}
            >
              <style type="text/css">{TCLE_EDITOR_FORMAT_CSS}</style>
              <TcleEditorToolbar />
              <ReactQuill
                style={{ height: '500px' }}
                value={this.state.editorValue}
                onChange={this.handleChange}
                modules={this.modules}
                formats={this.formats}
                disabled={this.state.disabled}
                ref={this.setReactQuillRef}
              />

              <div style={{ textAlign: 'right', marginTop: '50px' }}>
                <Button
                  type="primary"
                  className="add-procedure"
                  loading={this.state.loading}
                  onClick={this.handlePreviewClick}
                >
                  PREVIEW
                </Button>
              </div>
            </Card>
            <div
              ref={this.setLayoutMeasureRef}
              aria-hidden="true"
              style={{
                boxSizing: 'border-box',
                left: '-10000px',
                pointerEvents: 'none',
                position: 'absolute',
                visibility: 'hidden',
                width: `${TCLE_MEASUREMENT_CANVAS_WIDTH_PX}px`,
              }}
            />
            <Col xs={0} sm={24}>
              <div className="tcle-limit-feedback" style={{ marginTop: 12 }}>
                <Typography.Text className="tcle-character-counter" strong>
                  {this.state.charCount}
                  {' / '}
                  {TCLE_CHARACTER_LIMIT}
                  {' caracteres'}
                </Typography.Text>
                <Typography.Text
                  className="tcle-character-breakdown"
                  style={{ display: 'block' }}
                >
                  Composição do total:
                  {' '}
                  {characterBreakdown.textCharacters}
                  {' de texto + '}
                  {characterBreakdown.lineBreaks}
                  {characterBreakdown.lineBreaks === 1
                    ? ' quebra ou espaçamento estrutural.'
                    : ' quebras e espaçamentos estruturais.'}
                </Typography.Text>
                {layoutFeedback !== null && (
                  <Typography.Text
                    className="tcle-page-usage"
                    strong
                    type={this.state.layoutStatus === 'invalid' ? 'danger' : undefined}
                    style={{ display: 'block' }}
                  >
                    {layoutFeedbackText}
                  </Typography.Text>
                )}
                <Typography.Paragraph style={{ marginBottom: 4 }}>
                  Quebras de linha e parágrafos vazios aparecem na composição e também ocupam
                  espaço vertical na página.
                  O salvamento considera os dois limites, reservando o cabeçalho e as assinaturas.
                </Typography.Paragraph>
                <Typography.Text>
                  {contentValidation.overCharacterLimit
                    ? `Limite excedido em ${Math.abs(contentValidation.remaining)} ${Math.abs(contentValidation.remaining) === 1 ? 'caractere' : 'caracteres'}. O conteúdo foi mantido; reduza-o para salvar.`
                    : nearLimit
                      ? `Próximo do limite: ${contentValidation.remaining === 1 ? 'resta' : 'restam'} ${contentValidation.remaining} ${contentValidation.remaining === 1 ? 'caractere' : 'caracteres'}.`
                      : `Restam ${contentValidation.remaining} caracteres.`}
                </Typography.Text>
                {this.state.layoutStatus === 'invalid' && (
                  <Typography.Paragraph type="danger">
                    {layoutFeedback !== null && layoutFeedback.kind === 'width'
                      ? `Há uma palavra ou sequência sem espaços larga demais para a folha.
                         Insira espaços ou reduza-a para habilitar o salvamento.`
                      : 'O texto excede o espaço disponível nesta página. Reduza o conteúdo ou as quebras de linha para salvar.'}
                  </Typography.Paragraph>
                )}
                {this.state.legacyOversized && (
                  <Typography.Paragraph type="warning">
                    Conteúdo legado acima do limite: ele foi carregado integralmente e não será
                    truncado ou migrado. Reduza-o para salvar.
                  </Typography.Paragraph>
                )}
              </div>
            </Col>
            <Col xs={0} sm={24}>

              <Modal
                title="Preview"
                visible={this.state.modalVisible}
                onCancel={this.handleCancel}
                width={previewModalWidth}
                height={600}
                footer={[
                  <Button key="ok" type="primary" onClick={this.handleCancel}>
                    OK
                  </Button>,
                ]}
              >
                <div className="tcle-visible-preview">
                  <div dangerouslySetInnerHTML={{ __html: this.state.previewhtml }} />
                </div>

              </Modal>

            </Col>
          </Form>
        </Content>
      ) : (
        null
      );
    return institutionAcepted || this.redirectToPreAnesthesia();
  }
}

function mapStateToProps(state) { return state; }

const connected = withRouter(connect(mapStateToProps)(Form.create()(PreAnesthesiaSettingsTcle)));
export default connected;
